module.exports = __webpack_public_path__ + "media/icons/upload-033e7726.png";